import React, { Component } from 'react';
import { Form,Loader,Container,Header,Icon,Button,Modal } from 'semantic-ui-react';
import formsCatalog from './FormsCatalog.js';
import emailjs from 'emailjs-com';
import ImageUploader from "react-images-upload";
import Axios from 'axios';
const API_URL = 'https://inspekt-open-backend.herokuapp.com' // 'http://localhost:3001'

class Selectnature extends Component {

  constructor(props){
    super(props)
    this.state = {loading:true,expertise:[],pictures: [],brands:[],openmodaluserinformations: false,submitloading:false}
    this.onDrop = this.onDrop.bind(this);
    this.phoneinput = React.createRef();
    this.emailinput = React.createRef();
    this.submitbutton = React.createRef();
  }
  
  dataTransmissionToTheDealer = async()=>{

    if(!this.state.useremail){
      this.emailinput.current.focus();
      this.setState({openmodaluserinformations:true});
    }else if(!this.state.userphone){
      this.phoneinput.current.focus();
      this.setState({openmodaluserinformations:true});
    }else{
      this.setState({submitloading:true});
      const data = await new Promise((resolve,reject)=>{
        let formdata = new FormData();
        this.state.pictures.forEach((value,index)=>{
          formdata.append('filedata',value);
          if(index==this.state.pictures.length-1){
            resolve(formdata);
          }
        })
      })
  
      console.log('axios request data', data)
  
      const axiosResponse = await Axios({
        method: "post",
        url: `${API_URL}/upload`,
        data,
        config: { headers: { "Content-Type": "multipart/form-data" } }
      });

      const imageurl = await Promise.resolve(
        axiosResponse.status==200
        ?axiosResponse.data.map(element=>element.location)
        :[]
      );

      console.log('axiosResponse : ',imageurl);
  
      const templateParams = await Promise.resolve( {
        "reply_to": "reply_to_value",
        "from_name": this.state.useremail,
        "to_name": "Manière Agriviti",
        "message_html": JSON.stringify(this.state.brand)+JSON.stringify(this.state.expertise)+JSON.stringify(this.state.username)+JSON.stringify(this.state.useremail)+JSON.stringify(this.state.userphone)+JSON.stringify(this.state.company)+JSON.stringify(this.state.postcode)+JSON.stringify(this.state.town)+JSON.stringify(imageurl)
      });
     
      //email sending of this.state.expertise
      emailjs.send('smtp_server','template_va829UdN', templateParams, 'user_VtOWCcg8bYKhCqLPO5eFS')
        .then((response) => {
           console.log('SUCCESS!', response.status, response.text);
           this.setState({submitloading:false});
           alert('Votre demande a bien été reçue : nous revenons vers vous rapidement.');
           window.location.reload();
        }, (err) => {
           console.log('FAILED...', err);
           
        });
    }
    
    }

  handleChange = async(event,valueselected) => {
    const nature = this.props.naturelist.filter(nature=>nature.value===valueselected.value);

    //build an array of object{value,text} of brand for Form.Select Component
    for (let [key, value] of Object.entries(formsCatalog)) {

      if(key===nature[0].value){
         const brands = value.brands;
         console.log('marques : ',brands)
         if(brands){
          this.state.brands = await Promise.resolve(brands.map(element=>({value:element,text:element})));
         }
         
      }
    }
    if(nature[0]){
      this.setState({ nature:nature[0] });
    }

  }

  inputHandleChange = (event,data)=>{

    const inputvalue = data.value;
    const labelvalue = data.placeholder;
    if(inputvalue && !this.focus){
      this.expertise = ([...this.state.expertise,{[labelvalue]:inputvalue}]);
      this.setState({expertise:this.expertise});
    }
    
    console.log('state : ',this.state);

  }

  toggleHandleChange = (event,data)=>{

    const inputvalue = data.label;
    this.state.expertise=([...this.state.expertise,{option:inputvalue}])
    console.log('state : ',this.state);
  }

  onDrop(picture) {
    this.setState({
        pictures: this.state.pictures.concat(picture),
    });
  }

  brandInputBuilder=()=>{
    if(this.state.nature){

      const brandoptionarray = this.state.brands.map((dataelement,index)=>({key:index,value:dataelement.value,text:dataelement.value}));
      console.log('brandsoptionarray : ',brandoptionarray);

      return(
        <div>
          <Form.Select 
            //key={addOnsCatalog[element].property && addOnsCatalog[element].property}
            label="Marque" 
            placeholder="Marque"
            options={brandoptionarray}
            //list={addOnsCatalog[element].property && addOnsCatalog[element].property}
            onChange={(event,data)=>(
              data.value && this.setState({brand:data.value}))}
          />
        </div>
      )
    }          
  }

  identificationInputBuilder = ()=>{
    if(this.state.identificationformlist!==undefined && this.state.nature){
      const addOnsCatalog = this.state.identificationformlist.addOns;
      const addOnsOfNatureSelected = this.state.nature.formStepsTypes[2].addOns; //storage of all addons of step 2
      const regularOfNatureSelected = this.state.identificationformlist.regular; //storage of regular of step 2

      //input from regular list

      const InputRegular = regularOfNatureSelected.map(element=>(
      <Form.Input key={element.property} label={element.title} placeholder={element.title} onChange={this.inputHandleChange}/>
      ));

      //input from addOns list
      const InputFromAddonsOfNatureSelected = addOnsOfNatureSelected.map(element=>(<Form.Input key={addOnsCatalog[element].property} label={addOnsCatalog[element].title} placeholder={addOnsCatalog[element].title} onChange={this.inputHandleChange}/>));

      const totalinput = [...InputRegular,...InputFromAddonsOfNatureSelected];
      return(totalinput);
    }
    

  }

  configurationInputBuilder = ()=>{
    if(this.state.configurationformlist!==undefined && this.state.nature){
      const addOnsCatalog = this.state.configurationformlist.addOns;
      const addOnsOfNatureSelected = this.state.nature.formStepsTypes[3].addOns; //storage of all addons of step 2

      //const firstAddons = addOnsOfNatureSelected[0];

      const InputFromAddonsOfNatureSelected = addOnsOfNatureSelected.map(
        (element)=>{
          if(addOnsCatalog[element].data){

            const selectoptionarray = addOnsCatalog[element].data.map(dataelement=>({key:dataelement,value:dataelement,text:dataelement}));

            return(
              <div>
                <Form.Select 
                  //key={addOnsCatalog[element].property && addOnsCatalog[element].property}
                  label={addOnsCatalog[element].title && addOnsCatalog[element].title} 
                  placeholder={addOnsCatalog[element].title}
                  options={selectoptionarray}
                  //list={addOnsCatalog[element].property && addOnsCatalog[element].property}
                  onChange={this.inputHandleChange}
                />
              </div>
            )
          }else if(addOnsCatalog[element].toggle){
            return(
              <div className='togglebtn'>
                {
                  addOnsCatalog[element].title
                }
                {
                  addOnsCatalog[element].toggle.map(elementcheckbox=><Form.Checkbox toggle key={elementcheckbox} label={elementcheckbox} onChange={this.toggleHandleChange}/>)
                }
                
              </div>
            )
          }
          else{
            return(
              <Form.Input 
                key={addOnsCatalog[element].property}
                label={addOnsCatalog[element].title} 
                placeholder={addOnsCatalog[element].title}
                onChange={this.inputHandleChange}
              />
            )
          }
        
        }
      );

      return(InputFromAddonsOfNatureSelected);
    }
    

  }

  async componentDidMount(){
    //loading datas form formcatalog
    this.state.identificationformlist = await Promise.resolve(formsCatalog.formSteps({step:2}));
    this.state.configurationformlist = await Promise.resolve(formsCatalog.formSteps({step:3}));
    this.state.picturerequiredlist = await Promise.resolve(formsCatalog.formSteps({step:4}));

    this.setState({loading:false});
    
  }

  async componentDidUpdate(){
     console.log('state updated : ',this.state); 
  }

  render() {
    const naturelist = this.props.naturelist;
    const { openmodaluserinformations } = this.state;
    const { submitloading } = this.state;

    return (
        
        <Container className="natureselect">
          <Header as='h3' className='headertitle'>
            <Icon name='edit' />
            <Header.Content>Dites-nous en plus sur votre machine.</Header.Content>
          </Header>
          
              {
                !this.state.loading?
                <div>
                  <Form onSubmit={this.dataTransmissionToTheDealer}>
                    <Form.Select
                      className='mainselect'
                      label='Type de machine'
                      options={naturelist}
                      placeholder='Sélectionner'
                      onChange={this.handleChange}
                    />
                  
                    {
                    this.brandInputBuilder()
                    }
                  {
                    this.identificationInputBuilder()
                  }
                  {
                    this.configurationInputBuilder()
                  }
                  {this.state.nature &&<Form.Input label='Nom de votre société' placeholder='Société'>
                    <input onChange={(event)=>this.setState({company:event.target.value})}/>
                  </Form.Input>
                  }
                  {this.state.nature &&<Form.Input label='Votre nom et prénom' placeholder='Nom et prénom'>
                    <input onChange={(event)=>this.setState({username:event.target.value})}/>
                  </Form.Input>
                  }
                  {this.state.nature &&<Form.Input label='Code postal' placeholder='Code postal'>
                    <input onChange={(event)=>this.setState({postcode:event.target.value})}/>
                  </Form.Input>
                  }
                  {this.state.nature &&<Form.Input label='Ville' placeholder='Ville'>
                    <input onChange={(event)=>this.setState({town:event.target.value})}/>
                  </Form.Input>
                  }
                  {this.state.nature &&<Form.Input id='useremail' iconPosition='left' label='Votre email' placeholder='Email'>
                    <Icon name='at' />
                    <input  ref={this.emailinput} value={this.state.useremail} onChange={(event)=>this.setState({useremail:event.target.value})}/>
                  </Form.Input>
                  }
                  {this.state.nature &&<Form.Input iconPosition='left' label='Votre numéro de téléphone' placeholder='Portable'>
                    <Icon name='phone' />
                    <input ref={this.phoneinput} value={this.state.userphone} onChange={(event)=>this.setState({userphone:event.target.value})}/>
                  </Form.Input>
                  }
                  {
                    this.state.nature&&<ImageUploader
                    withIcon={true}
                    withPreview={true}
                    label="Notre proposition sera meilleure avec de belles images"
                    buttonText="Joindre mes photos"
                    onChange={this.onDrop}
                    imgExtension={[".jpg",".jpeg", ".gif", ".png", ".gif"]}
                    maxFileSize={5242880}
                  />
                  }
                  {<Form.Field loading={submitloading} control={Button} id='submitbutton'>Demander une estimation de reprise</Form.Field>
                  }
                  
                  </Form>
                </div>
                :
                <Loader active inline='centered' />
              }
              <Modal
                open={openmodaluserinformations}
                onOpen={() => this.setState({ openmodaluserinformations: true })}
                onClose={() => this.setState({ openmodaluserinformations: false })}
                size='small'
              >
                <Modal.Header>Presque !</Modal.Header>
                <Modal.Content>
                  <p>Saisissez votre email et votre téléphone pour que nous puissions vous transmettre noptre proposition.</p>
                </Modal.Content>
                <Modal.Actions>
                  <Button icon='check' content="J'ai compris" onClick={() => this.setState({ openmodaluserinformations: false })} />
                </Modal.Actions>
              </Modal>
        </Container>
        
    )
  }
}

export default Selectnature
